import {Select, Input, Button, Col, DatePicker} from "antd";

import styled from "styled-components";
import {CloseOutlined} from "@ant-design/icons";

export const StyledRangePickerContainer = styled.div`
    .ant-picker-dropdown {
        position: absolute !important;
        z-index: 1050;
    }

    .ant-picker-panel-container {
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12),
            0 9px 28px 8px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
    }

    @media (max-width: 768px) {
        .ant-picker-panels {
            flex-direction: column;
        }

        .ant-picker-dropdown {
            top: 100px !important;
            left: 0 !important;
            right: 0 !important;
            transform: none !important;
        }
    }
`;

export const RangePicker = styled(DatePicker)`
    top: 100px;

    @media (max-width: 768px) {
        .ant-picker-dropdown {
            top: 100px;
        }
    }
`;

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: ${props => (props.mb ? props.mb : "20px")};
    display: flex;
    .ant-select-selector {
        width: 100%;
    }
    @media (max-width: 768px) {
        .ant-select-selector {
            font-size: 12px;
        }
    }
`;

export const DateSelectCol = styled(Col)`
    display: flex;
    @media (max-width: 768px) {
        margin-left: 0px;
        margin-bottom: 20px;
    }
`;

export const SearchInput = styled(Input.Search)`
    @media (max-width: 768px) {
        min-width: unset;
        width: 100%;
    }
    .ant-input-group-addon {
        background-color: transparent;
    }
`;

export const EnterButton = styled(Button)``;

export const CloseIcon = styled(CloseOutlined)`
    cursor: pointer;
`;

export const FilterLabel = styled.h5`
    margin: 0 0 8px 0;
    font-weight: 500;
    font-size: 14px;
    color: #333;
    line-height: 1.4;
`;

export const DatePickerWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;
